<app-section sectionTitle="Selling List">
  @if (outputItemsGroupedBySellLocation().length === 0) {
    <p>No items to sell! Make sure you mark the wanted crafts in the Setup Page!</p>
  }
  @for (entry of outputItemsGroupedBySellLocation(); track entry[0].name; let groupIndex = $index) {
    <app-subsection [subSectionTitle]="entry[0].displayName + ' (Total Weight: ' + (entry[1].totalWeight | number: '1.0-0') + ' kg)'">
      @for (outputItem of entry[1].items; track outputItem.item.uniqueName; let i = $index) {
        <mat-card style="margin-bottom: 16px">
          <mat-card-content style="padding: 16px">
            <div style="display: flex; align-items: center; gap: 16px">
              <!-- Step Number -->
              <mat-chip-set>
                <mat-chip color="primary" selected>{{ i + 1 }}</mat-chip>
              </mat-chip-set>

              <!-- Item Image -->
              <div style="flex-shrink: 0">
                <app-item-image [item]="outputItem.item" [size]="60" [hideTooltip]="true" />
              </div>

              <!-- Item Details -->
              <div style="flex: 1; min-width: 0">
                <h3 style="margin: 0 0 16px 0; font-weight: 500">
                  {{ outputItem.item.localizedName }}
                </h3>

                <!-- Selling Info Grid -->
                <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)); gap: 16px; margin-bottom: 16px">
                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Quantity</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ outputItem.totalAmount() | number: '1.2-2' }}</span>
                  </div>

                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Weight</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ outputItem.totalWeight() | number: '1.0-0' }} kg</span>
                  </div>

                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Sell To</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ outputItem.sellPriceType()?.friendlyName }}</span>
                  </div>

                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Unit Price</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ outputItem.sellUserPrice() | number: '1.0-0' }}</span>
                  </div>

                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Item Income Before Fees and Taxes</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ outputItem.totalSellIncomeWithoutFeeOrTax() | number: '1.0-0' }}</span>
                  </div>

                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Setup Fees</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ outputItem.totalSetupFeeCost() | number: '1.0-0' }}</span>
                  </div>

                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Sales Taxes</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ outputItem.totalSalesTaxCost() | number: '1.0-0' }}</span>
                  </div>

                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Item Income With Fees and Taxes</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ outputItem.totalSellIncomeWithFeeAndTax() | number: '1.0-0' }}</span>
                  </div>
                </div>

                <!-- Action Buttons -->
                <div style="display: flex; gap: 8px; align-items: center; flex-wrap: wrap">
                  <app-copy-text-button [text]="outputItem.item.localizedName"></app-copy-text-button>
                  <app-check-price-button [itemUniqueName]="outputItem.item.uniqueName"></app-check-price-button>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      }
    </app-subsection>
  }
</app-section>
